import Axios from "../axios";
import {advertisementApiConstants} from "../constants/ApiConstant";

// App-facing advertisement read used by the client Bell Dashboard carousel.
//
//   GET /api/v1/app/advertisement
//     → { speed: <ms>, settings: [{ id, title, description, url, enabled }] }
//
// Only active + enabled ads are returned. Resolves with a normalised
// { speed, ads } shape the slider can consume directly; rejects on error so the
// caller can hide the section.
export async function fetchAppAdvertisements() {
    const response = await Axios.get(advertisementApiConstants.APP_ADVERTISEMENT);
    const data = response?.data || {};
    const settings = Array.isArray(data.settings) ? data.settings : [];

    // Map the backend shape onto the slider's { image, title, description }.
    const ads = settings
        .filter((ad) => ad?.url)
        .map((ad) => ({
            id: ad.id,
            image: ad.url,
            title: ad.title,
            description: ad.description,
        }));

    return {speed: data.speed || null, ads};
}
